// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/download.js';

import { paths } from '../generated/download';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('download', Original, paths);
